// @ts-nocheck


import L from 'leaflet';
import 'leaflet-plugin-trackplayback';

import { findTick } from './utils';



















export const createPlaybackData = (
history) =>

history.
filter(
  (item) =>
  Number.isFinite(item?.geoPosition?.lat) &&
  Number.isFinite(item?.geoPosition?.lng) &&
  Number.isFinite(new Date(item.timestamp).getTime())
).
map(({ geoPosition: { lat, lng }, direction: dir, timestamp }, index) => ({
  lat,
  lng,
  time: Math.round(new Date(timestamp).getTime() / 1000),
  dir,
  info: [{ key: 'index', value: index }]
}));

export const createTrackPlayback = (
data,
map,
options) =>
{
  if (!data.length) return null;
  return new L.trackplayback(data, map, options);
};

export const bindPlaybackTicks = (
playback,
history,
onStateChange) =>
{
  const handleTick = (item) => {
    const track = item?.target?.tracks?.[0];
    const timeTick = track?._timeTick || {};
    const tick = findTick(Object.keys(timeTick), item.time);

    if (!history.length || tick === undefined) return;

    onStateChange(() => ({
      currentIndex: timeTick[tick],
      currentTick: item.time,
      isEnded: playback.getCurTime() === playback.getEndTime()
    }));
  };

  playback.on('tick', handleTick);
  return () => playback.off && playback.off('tick', handleTick);
};

export const disposeTrackPlayback = (playback) => {
  if (!playback) return;
  if (playback.stop) playback.stop();
  if (playback.dispose) playback.dispose();
};
